import {FocusEventHandler} from "react";

export interface FieldDateSwitchValue {
    absolute?: string
    relative?: string
}

const numRegex = RegExp(/([\d]+)/)

interface FieldDateSwitchProps {
    id?: string
    required?: boolean
    small?: boolean
    label?: string
    value?: FieldDateSwitchValue
    invalid?: boolean
    disabled?: boolean
    help?: string
    placeholder?: string
    onBlur?: FocusEventHandler<any> | undefined
    onChange?: (value: FieldDateSwitchValue) => void
}

function FieldDateSwitch({
                             id,
                             disabled,
                             label,
                             small,
                             invalid,
                             value,
                             required,
                             placeholder,
                             onBlur,
                             onChange
                         }: FieldDateSwitchProps) {
    const vA = value?.absolute ? isNaN(new Date(value?.absolute).valueOf()) ? '' : (new Date(value?.absolute)).toISOString().substring(0, 10) : ''



    const relVal = value?.relative ? `${value?.relative}` : ''
    const relDurationType = relVal.substring(0, 1) || 'd'
    const relValue = numRegex.test(relVal) ? numRegex.exec(relVal)![0] : relVal
    const isRelative = !Boolean(value?.absolute)

    const dateType = isRelative ? 'relative' : 'absolute'


    return <>
        <div id={id} className={`field ${required ? 'required' : ''}`}>
            {label && <label className={`label`}>{label}</label>}
            <div className={'field has-addons'}>
                <div className="control">
                <span className="select">
                    <select
                        onChange={e => {
                            onChange && onChange({
                                relative: e.target.value === 'relative' ? 'd' : undefined,
                                absolute: e.target.value === 'absolute' ? '-' : undefined,
                            })
                        }}
                        value={dateType}
                    >
                        <option value={'relative'}>Relativ</option>
                        <option value={'absolute'}>Absolut</option>
                    </select>
                </span>
                </div>
                {!isRelative &&
                    <div className="control">
                        <input
                            id={id ? `${id}-input` : undefined}
                            disabled={disabled}
                            className={`input is-fullwidth ${small ? 'is-small' : ''} ${invalid ? 'is-danger' : ''} ${required ? 'required' : ''}`}
                            type={"date"}
                            value={vA}
                            placeholder={placeholder}
                            onBlur={onBlur}
                            onChange={e => {
                                const d = new Date(e.target.value)
                                onChange && onChange({
                                    absolute: isNaN(d.valueOf()) ? undefined : d.toISOString()
                                })
                            }}
                        />
                    </div>
                }
                {isRelative &&
                    <>
                        <div className="control">
                            <input
                                className="input"
                                type="number"
                                min={0}
                                value={relValue}
                                placeholder={placeholder}
                                onBlur={onBlur}
                                onChange={e => {
                                    onChange && onChange({
                                        relative: relDurationType + e.target.value
                                    })
                                }}
                            />
                        </div>
                        <div className="control">
                            <span className="select">
                                <select
                                    onChange={e => {
                                        onChange && onChange({
                                            relative: e.target.value + relValue
                                        })
                                    }}
                                    value={relDurationType}
                                >
                                    <option value={'d'}>Tage</option>
                                    <option value={'h'}>Stunden</option>
                                    <option value={'m'}>Minuten</option>
                                </select>
                            </span>
                        </div>
                    </>
                }
            </div>
        </div>
    </>
}

export {
    FieldDateSwitch
}
